'use strict';

import * as Props from '../Props';

const angular = require('angular');

const RichTextAreaProperties = {
    Basic: {
        'ControlType': 'RichTextArea',
        'Label': {
            name: 'label',
            selectedValue: 'RichText-Area',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe'
        },
        'Field Name': Props.getFieldName('RichText_Area'),
        'Data Field Name': Props.getDataFieldName('RichText_Area'),
        'Value': {
            name: 'value',
            selectedValue: '',
            type: 'textbox',
            onClickFunction: 'existingDataField',
            addOnButton: 'fa fa-function',
            onChangeFunction: 'updateDSField',
            hidden: true
        },
        'DSName': {
            selectedValue: '',
            hidden: true
        },
        'Required': {
            name: 'required',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        }
    },
    Display: {
        'Read-only': {
            name: 'read.only',
            selectedValue: false,
            type: 'checkbox'
        },
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        },
        'Char-Limit': {
            name: 'char.limit',
            selectedValue: 3000,
            type: 'number',
            min: 1,
            max: 5000
        },
        'HasMic': {
            name: 'show.mic',
            selectedValue: false,
            type: 'checkbox'
        }
    },
    Style: angular.copy(Props.labelStyleObject),
    ControlStyle: {
        'Name': {
            hideSection: true
        }
    },
    Margin: angular.copy(Props.marginObject),
    Advance: {
        'Tabindex': {
            name: 'tabindex',
            selectedValue: '',
            type: 'number'
        },
        'Searchable': angular.copy(Props.Searchable),
        'Reportable': angular.copy(Props.Reportable),
        'customizable-column': angular.copy(Props.Customizable),
        'Name': {
            selectedValue: 'Advanced',
            hidden: true
        }
    },
    Events: angular.copy(Props.elementEventsObject)
};

export default RichTextAreaProperties;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Rich_Text_Area.ts